import React from "react";

import LinkIcon from "@uui/Link01";

import VideoPreview from "@app/analytics/components/VideoPreview";

import CopyButton from "@rui/CopyButton";
import { Row, Column } from "@rui/Stack";

import { Card, Label, Quote, Timestamp, LinkButton } from "./styles";
import HighlightChip, { HighlightChipProps } from "../HighlightChip";
import JumpToButton from "../JumpToButton";

interface HighlightProps {
  type: HighlightChipProps["type"];
  label: string;
  timestamp?: string;
  quote?: string | null;
  clipSrc?: string | null;
  deepLink?: string;
  duration: number;
  onClick?: () => void;
}

const Highlight = ({
  label,
  quote,
  timestamp,
  type,
  clipSrc,
  deepLink,
  duration,
  onClick,
}: HighlightProps) => {
  return (
    <Card onClick={onClick}>
      <Row justifyContent="space-between" spacing={1} sx={{ width: "100%" }}>
        <Column spacing={0.5}>
          <Row variant="left" spacing={1} minHeight="28px">
            <HighlightChip type={type} />
            {timestamp && <Timestamp>{timestamp}</Timestamp>}
            {deepLink && (
              <CopyButton
                copyValue={deepLink}
                renderIconButton={({ onClick, children }) => (
                  <LinkButton
                    className="highlight__copy-link"
                    onClick={onClick}
                  >
                    {children ?? <LinkIcon />}
                  </LinkButton>
                )}
                stopPropagation
                tooltip="Copy link to this highlight"
              />
            )}
          </Row>
          <Label>{label}</Label>
          <Quote>{quote}</Quote>
        </Column>

        {clipSrc && duration ? (
          <VideoPreview videoSrc={clipSrc} duration={duration} />
        ) : onClick ? (
          <JumpToButton onClick={onClick}>Jump to</JumpToButton>
        ) : null}
      </Row>
    </Card>
  );
};

export default Highlight;
